
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import CharField from '@/components/processing_steps/commons/fields/CharField.vue'
import { isColorTooLight } from '@/utils/colours'

@Component({
  components: {
    CharField
  }
})
export default class ColorInput extends Vue {
@Prop() value: string
@Prop({ default: false }) darkColorsOnly: boolean

localValue = "#"
placeholder = '#fbbb59'
tooLightError = false

get invalidHex (): boolean {
  return this.localValue.length > 1 && !/^#[0-9a-fA-F]{6}$/.test(this.localValue)
}

@Watch('value')
onValueChange (value: string): void {
  this.localValue = value
}

mounted (): void {
  this.localValue = this.value
}

updateLocatValue (value: string): void {
  this.localValue = value
}

updateValue (event: Event): void {
  const color = (event.target as HTMLInputElement).value
  this.localValue = color
  if (this.darkColorsOnly && isColorTooLight(color)) {
    this.tooLightError = true
    this.$emit("change", color)
    this.$emit("update:value", color)
    return
  }
  this.tooLightError = false
  this.$emit("change", color)
  this.$emit("update:value", color)
}

updateValueText (value: string): void {
  if (!value.startsWith('#')) {
    value = '#' + value
  }
  if (this.darkColorsOnly && isColorTooLight(value)) {
    this.tooLightError = true
    this.$emit("change", value)
    this.$emit("update:value", value)
    return
  }
  this.tooLightError = false
  this.$emit("change", value)
  this.$emit("update:value", value)
}
}
